<div class="modal-container main-font">
  <div class="title-container">
    <p class="mb-0 title-text">
      Impostazione del calendario per il mese prossimo
    </p>
    <p class="mb-0 subtitle">
      Scegli se duplicare l'ultima settimana del mese corrente o iniziare con un
      calendario vuoto
    </p>
  </div>
  <label nz-checkbox [(ngModel)]="checked" class="text-checkbox"
    >Duplica l'ultima settimana del mese corrente per il prossimo</label
  >
  <div class="btn-container">
    <button class="secondary-btn" (click)="closeModal()">Annulla</button>
    <button class="primary-btn" (click)="save()">Genera calendario</button>
  </div>
</div>
